module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/rooms/Room_AllRooms_05-lagoon.png";